import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';


export let cartCount = 0; 

export function updateCartCount(newCount) { 
  cartCount = newCount; 

}

export function     refreshCartCount() { 
  return cartCount; 

}

export async function clicks(path) {


    fetch(`${urls.BASE_URL}` + "/auth/clicks", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCsrfToken()
        },
        body: JSON.stringify({ 'page': path })
    });
    return;
}

export function useHandleAddToCart() {
    const navigate = useNavigate();
    const location = useLocation();
    const [quantity, setQuantity] = useState(1);
    async function addToCartFunc(e, q) {
        try {
            const response = await
                fetch(`${urls.BASE_URL}` + "/zedock-web/cart", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-XSRF-TOKEN": getCsrfToken()

                    },
                    body: JSON.stringify({
                        productId: e,
                        quantity: q
                    })
                });

            if (response.status === 401) {
                if (!document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'))[0].includes(e)) {
                    document.cookie = "products=" + ((document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)')) == null)
                        ? e + ","
                        : document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'))[0].split('products=')[1] + e + ","
                    );
                }
                navigate("/Cart", { state: { from: location } })
                return null;
            }
            navigate("/Cart")
        } catch (error) {
            document.cookie = "products=" + e + ",";
            navigate("/Cart")

            console.error("Error:", error);
        } finally {
        }
    };
    return addToCartFunc;

}
